module.exports = "/_next/static/images/kv_fade-54a884cce1aa6a096534746a6f3c8e96.png";